import {createAction} from "@reduxjs/toolkit";
export const mddifyChartType = createAction('modify/chartType');
